import React, { useEffect, useState } from 'react'
import { MinimalActionButton } from '../../../../../components/form/minimalActionButton'
import { useGeneralParams } from '../../../../../hooks/useDataPaginate'
import { formatDateWithTime } from '../../../../../utils/dateFormat'
import { setReloadMainTable } from '../../../../../store/slices/auth/authSlice'
import { DefaultParamsForRecall } from '../../../../../utils/defaulStates'
import { useSelector } from 'react-redux'
import { Section } from '../../../../../components/table/Section'
import { ModalForm } from '../../../../../components/modals/ModalForm'
import { RegistrarGastoValues } from '../../../../../FormSchemes/EfectivoHistorialEgresosScheme'
import { Actions } from '../../../../../components/form/actions'
import { DeleteValues } from '../../../../../FormSchemes/CuadernoScheme'

export const ListGastosTable = () => {
    const {
        dispatch,
        data, setData,
        paginate, setPaginate,
        selectedDay, setSelectedDay,
        stateData, setStateData,
        requestAuthPaginate,
        TableContainer,
        Paginator,
        formatFilters,
        Searcher,
        FilterSelect,
        RangeDate,
        TableSection,
        ActionSection,
        setSelectAllChecked,
        setIsChecked,
        setSelecteds,
        isChecked,
        selectAllChecked,
        selecteds,
        params,
        UpdateValuesModal,
        setCurrentData,
        setDeleteModal,
        deleteModal,
        currentData
    } = useGeneralParams()
    const reloadMainTable = useSelector(state => state.login.reloadMainTable)
    const [registrarGastoModal, setRegistrarGastoModal] = useState(false)
    const getDataPaginate = async () => {
        await requestAuthPaginate({
            method: 'get',
            url: `/compra/${params.compra_id}/efectivoHistorial/pag`,
            data: null,
            queries: paginate,
            setData: setData,
            setStateData: setStateData,
            setQueries: setPaginate,
            dispatch: dispatch,
            aditionalParams: { filterBy: 'nombre' }
        })
    }
    useEffect(() => {
        getDataPaginate();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), params.compra_id, paginate.estado, reloadMainTable]);

    useEffect(() => {
        setSelectAllChecked(false)
        setIsChecked(false)
        setSelecteds([])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...DefaultParamsForRecall(paginate), paginate.estado]);

    const recall = () => {
        setSelectAllChecked(false)
        setIsChecked(false)
        getDataPaginate()
        setSelecteds([])
        dispatch(setReloadMainTable())
    }

    const reloadTable = () => {
        dispatch(setReloadMainTable())
    }

    return (
        <Section>
            <ActionSection>
                <Actions
                    buttons={[
                        {
                            icon: 'minus',
                            label: 'Registrar Gasto',
                            action: () => setRegistrarGastoModal(true),
                            className: 'dark:bg-red-700 bg-red-500 text-white'
                        },
                    ]}
                />
                <Searcher
                    paginate={paginate}
                    setPaginate={setPaginate}
                    selectedDay={selectedDay}
                    setSelectedDay={setSelectedDay}
                    options={[
                        {
                            label: 'Nombre',
                            value: 'nombre'
                        },
                        {
                            label: 'Estado',
                            value: 'estado'
                        }
                    ]}
                    reloadTable={reloadTable}
                />
                <div className='flex gap-2 flex-wrap'>
                    <RangeDate
                        selectedDay={selectedDay}
                        setSelectedDay={setSelectedDay}
                        paginate={paginate}
                        setPaginate={setPaginate}
                    />
                    <FilterSelect
                        paginate={paginate}
                        setPaginate={setPaginate}
                        formatFilter={formatFilters}
                        name='estado'
                        options={[
                            {
                                label: 'Estado',
                                value: ''
                            },
                            {
                                label: 'Activo',
                                value: 'activo'
                            },
                            {
                                label: 'Inactivo',
                                value: 'inactivo'
                            }
                        ]}
                    />
                    <MinimalActionButton
                        icon='repeat'
                        label=''
                        action={recall}
                    />
                </div>
            </ActionSection>
            <TableSection
                stateData={stateData}
                paginator={Paginator}
                data={data}
            >
                <TableContainer
                    headers={[
                        {
                            label: '#',
                            columns: ['codigo_transaccion']
                        },
                        {
                            label: 'Entidad',
                            columns: ['nombre', 'encargado', 'producto_nombre']
                        },
                        {
                            label: 'Origen / Destino',
                            columns: ['user_nombres', 'user_apellidos', 'proveedor_encargado']
                        },
                        // {
                        //     label: 'Monto anterior Bs.',
                        //     columns: ['monto_anterior'],
                        //     numberValue: true,
                        //     sumDec: true
                        // },
                        {
                            label: 'Monto Bs.',
                            columns: ['monto'],
                            numberValue: true,
                            sumDec: true
                        },
                        // {
                        //     label: 'Monto actual Bs.',
                        //     columns: ['monto_actual'],
                        //     numberValue: true,
                        //     sumDec: true
                        // },
                        // {
                        //     label: 'Billetes Bs.',
                        //     columns: ['billetes'],
                        //     numberValue: true,
                        //     sumDec: true
                        // },
                        // {
                        //     label: 'Monedas Bs.',
                        //     columns: ['monedas'],
                        //     numberValue: true,
                        //     sumDec: true
                        // },
                        // {
                        //     label: 'Dolares en Bs.',
                        //     columns: ['dolares_en_bs'],
                        //     numberValue: true,
                        //     sumDec: true
                        // },
                        {
                            label: 'ingreso / egreso',
                            columns: ['ingreso'],
                            booleanState: true,
                            booleanOptions: ['ingreso', 'egreso']
                        },
                        {
                            label: 'Concepto',
                            columns: ['tipo'],
                        },
                        // {
                        //     label: 'CONFIRMACIÓN',
                        //     columns: ['verificado'],
                        //     boolean: true,
                        //     booleanOptions: ['Confirmado', 'Pendiente'],
                        //     booleanIconTrue: 'fa-check',
                        //     booleanIconFalse: 'fa-xmark'
                        // },
                        {
                            label: 'fecha de registro',
                            columns: ['createdAt'],
                            transform: true,
                            func: formatDateWithTime
                        },
                        {
                            label: 'Acciones',
                            actions: [
                                {
                                    type: 'delete',
                                    icon: 'fa-trash',
                                    action: (data) => UpdateValuesModal(data, setCurrentData, setDeleteModal),
                                    reference: 'id',
                                    tooltipText: 'Eliminar',
                                    validate: { value: 'abierto', validator: true }
                                }
                            ],
                            // stickyR: true
                        },
                    ]}
                    data={data.data}
                    checkList={false}
                    selecteds={selecteds}
                    setSelecteds={setSelecteds}
                    selectAllChecked={selectAllChecked}
                    setSelectAllChecked={setSelectAllChecked}
                    isChecked={isChecked}
                    setIsChecked={setIsChecked}
                    stateData={stateData}
                />

            </TableSection>
            {
                registrarGastoModal &&
                <ModalForm
                    setModal={setRegistrarGastoModal}
                    label='Registro de Gasto'
                    dataValues={RegistrarGastoValues(null, params.compra_id)}
                    urlApi={`/registrarGasto`}
                    method={'post'}
                    call={() => {
                        recall()
                    }}
                    buttonLabel='Registrar'
                />
            }
            {
                deleteModal &&
                <ModalForm
                    setModal={setDeleteModal}
                    label='Eliminar'
                    dataValues={DeleteValues(currentData)}
                    urlApi={`/efectivoHistorial/${currentData.id}`}
                    method={'delete'}
                    call={() => {
                        recall()
                    }}
                    buttonLabel='Eliminar'
                />
            }
        </Section>
    )
}